import React from 'react';
import {Tabs} from '@ey/canvascoreservices';
import {getTheme} from '../../utils/utils';
import styled from 'styled-components';

export default function TabBar({
	activeTab,
	badge,
	onTabChange,
	styleName,
	tabColor,
	tabs,
	ellipse,
	...props
}) {
	return (
		<StyledTabs>
			<Tabs
				activeTab={activeTab}
				badge={badge}
				onTabChange={onTabChange}
				styleName={styleName}
				tabColor={tabColor}
				tabs={tabs}
				ellipse={ellipse}
				theme={getTheme()}
				{...props}
			/>
		</StyledTabs>
	);
}

const StyledTabs = styled.section`
	.StyledTab {
		.motif-tab-navigation-horizontal {
			border-bottom: 0;
			.motif-tab-button {
				box-shadow: none;
				&.motif-active {
					color: ${(props) => props.theme.color[`grey500`]};
				}
				&:hover,
				&:focus {
					outline: none;
				}
			}
		}
	}
`;
